
import { Component, Vue, Prop } from 'nuxt-property-decorator'
import {
  differenceInSeconds,
} from 'date-fns'
import { convertToLocalDateTime } from '@/utils/dates.utils'

const RERENDER_INTERVAL = 1000
const ONE_DAY = 60 * 60 * 24
const ONE_HOUR = 60 * 60
const ONE_MINUTE = 60

@Component
export default class AppTimer extends Vue {
  /**
   * Date in iso string format with timezone
   */
  @Prop({ type: String, required: true })
  readonly endTime!: string

  @Prop({ type: Boolean, default: false }) readonly plain!: boolean

  private currentTime = new Date().getTime()
  private interval: ReturnType<typeof setInterval> | null = null

  get isEnded () {
    return (this.diffInSeconds <= 1)
  }

  get diffInSeconds () {
    const localDate = convertToLocalDateTime(this.endTime)
    return differenceInSeconds(new Date(localDate), this.currentTime)
  }

  get getCountdown () {
    const timerData = {
      days: { value: 0, label: this.plain ? this.$t('timer-short.days') : this.$t('timer.days') },
      hours: { value: 0, label: this.plain ? this.$t('timer-short.hours') : this.$t('timer.hours') },
      minutes: { value: 0, label: this.plain ? this.$t('timer-short.minutes') : this.$t('timer.minutes') },
      seconds: { value: 0, label: this.plain ? this.$t('timer-short.seconds') : this.$t('timer.seconds') },
    }

    if (this.isEnded) {
      if (this.interval) {
        clearInterval(this.interval)
      }

      return timerData
    }

    const days = Math.floor(this.diffInSeconds / ONE_DAY)
    const hours = Math.floor((this.diffInSeconds - days * ONE_DAY) / ONE_HOUR)
    const minutes = Math.floor(
      (this.diffInSeconds - days * ONE_DAY - hours * ONE_HOUR) / ONE_MINUTE,
    )
    const seconds =
      this.diffInSeconds - days * ONE_DAY - hours * ONE_HOUR - minutes * ONE_MINUTE

    timerData.days.value = days
    timerData.hours.value = hours
    timerData.minutes.value = minutes
    timerData.seconds.value = seconds

    return timerData
  }

  beforeDestroy () {
    if (this.interval) {
      clearInterval(this.interval as ReturnType<typeof setInterval>)
    }
  }

  mounted () {
    this.interval = setInterval(() => {
      this.currentTime = new Date().getTime()
    }, RERENDER_INTERVAL)
  }
}
